<app-summary></app-summary>

<div class="tab-content">
  <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show">
    <spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
    <div class="row">
      <div class="col-md-12">
        <div class="tab" role="tabpanel">
          <ul class="nav nav-tabs" role="tablist" style="margin-top: 0px;">
            <li role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'approval'}" (click)="navtabclick('approval')"
                name="pendingapprovals" aria-selected="true">{{'componentPages.pendingapprove' | translate}}</a></li>
            <li role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'weightage'}" (click)="navtabclick('weightage')" name="weightage"
                aria-selected="false">{{'componentPages.weightageapprove' | translate}}</a></li>

          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade active show" id="pending">
              <div class="row">
                <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"> -->

                <!-- <div class="float-left my-1 ml-10" *ngIf="showdistdropdown && activesidetab == 'approval' && assessmentYear >= '2019-2020'">
                                    <label>Data Submission</label>
                                    <select [(ngModel)]="datasubmit" (change)="typechanged()" class="form-control custom-selectbox selectdis">
                                        <option value="statewise">State Level</option>
                                        <option value="districtwise">District Level</option>
                                    </select>
                                    </div> -->
                <!-- <div class="float-left my-1 ml-10" *ngIf="assessmentYear != '2019-2020' && assessmentYear != '2020-2021' ">
                                        <label>Data Submission</label>
                                        <select [(ngModel)]="datasubmit" disabled="" (change)="typechanged()" class="form-control custom-selectbox selectdis">
                                            <option value="statewise" >State Level</option>
                                             <option value="districtwise"[disabled] = "assessmentYear!='2019-2020'">District Level</option> -->
                <!-- </select> -->
                <!-- </div> -->

                <!-- </div> -->
                <div class="col-md-2">
                  <div>
                    <label>{{'header.assesmentyear' | translate }}<span class="text-star">*</span></label>
                    <select [(ngModel)]="assessmentYear" class="form-control custom-selectbox">
                      <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <label>{{'dataSubs.month' | translate }}&nbsp;<span class="text-star">*</span></label>
                    <select [(ngModel)]="monthlist['montharray']" (change)="selectOption($event.target.value)"
                      class="form-control custom-selectbox">
                      <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate }}</option>
                      <option *ngFor="let month of monthsList" [value]="month.key">
                        {{'monthmaps.' + month['value'] | translate}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="activesidetab == 'approval'">
                  <div>
                    <label>{{'header.state' | translate }}<span class="text-star">*</span></label>
                    <select [(ngModel)]="selectedstate" class="form-control custom-selectbox"
                      (change)="showdistrictdropdown(selectedstate)">
                      <option value="undefined">{{'tabledataforstates.selectstate' | translate}}</option>
                      <option *ngFor="let state of stateArrayList" value="{{state.uuid}}">
                        {{'tabledataforstates.' + state['name'] | translate}}</option>
                    </select>
                    <span style="color:red" [hidden]="selectedstate">{{'viewreprt.validation' | translate}}</span>

                  </div>
                </div>
                <div class="col-md-3"
                  *ngIf="showdistrictdrop  && activesidetab == 'approval'">
                  <div>
                    <label>{{'header.district' | translate}}<span class="text-star">*</span></label>
                    <select [(ngModel)]="selectedistrict" class="form-control custom-selectbox">
                      <option value="undefined">{{'trigManage.selectdistrict' | translate}}</option>
                      <option *ngFor="let district of districtarrayList" value="{{district['uuid']}}">
                        {{'districtsdata.' + district['name'] | translate}}</option>
                    </select>
                    <span style="color:red" [hidden]="selectedistrict">{{'viewreprt.validation1' | translate}}</span>

                  </div>
                </div>
                <div class="col">
                  <label class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;</label>
                    <button class="btn btn-info" (click)="getReports()" name="submit"
                      type="button">{{'dataSubs.VIEW' | translate}}</button>
                </div>

                <div class="col-auto w-100 mt-3">
                  <div class="d-flex justify-content-end w-100">
                    <div class="btn-group">
                      <!-- <button class="btn btn-info btn-sm mr-2" (click)="approveclick()" name="approval" type="button">Approve</button> -->
                      <button class="btn btn-info" (click)="approveorrejectData('approve')" name="submit"
                        type="button">{{'header.submit' | translate }}</button>
                      <!-- <button class="btn btn-danger btn-sm" (click)="approveorrejectData('reject')" name="reject"
                        type="button">{{'dataSubs.reject' | translate}}</button> -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12" *ngIf="activesidetab == 'approval'?true:false">
                  <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm">
                    <!-- <cdk-virtual-scroll-viewport  #scrollViewport  -->
                    <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
                      [style.height]="admintableData.length > 0 ? '500px' : '185px'">
                      <table class="table text-center table-sm mt-1">
                        <thead class="thead-light">
                          <tr>
                            <th class="positiontest" [style.top]="inverseOfTranslation">
                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" (change)="checkallset(checkall)" name="selectall"
                                  [disabled]="disablechackall" [(ngModel)]="checkall" class="custom-control-input"
                                  id="selectall">
                                <label class="custom-control-label" for="selectall"></label>
                              </div>
                              <input type="checkbox" name="selectall" class="custom-control-input" id="selectall">
                            </th>
                            <th scope="col" class="positiontest" [style.top]="inverseOfTranslation">
                              {{'trigManage.sno' | translate}}</th>
                            <th>{{'trigManage.statename' | translate}}</th>
                            <th>{{'infotab.rank' | translate}}</th>
                            <th>{{'dataSubs.scoregen' | translate}}</th>
                            <th>{{'trigManage.view' | translate}}</th>
                          </tr>
                        </thead>
                        <tbody class="text-white">
                          <ng-container *ngFor="let table of admintableData;let i=index">
                            <tr>
                              <td>
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input" [(ngModel)]="table['ischecked']"
                                    id="{{i+1}}">
                                  <label class="custom-control-label" for="{{i+1}}"></label>
                                </div>
                              </td>
                              <td>{{i+1}}</td>
                              <!-- <td>{{'districtsdata.' + checkvalue(table['name']) | translate}}</td> -->
                              <td>{{ 'tabledataforstates.' + selectedStateName | translate }}</td>
                              <td>{{checkvalue(table['rank'])}}</td>
                              <td>{{checkscorevalue(table['score'])}}</td>
                              <td><a class="pointer" title="View Data"
                                  (click)="infoClick(table, table['id'], table['name'],table['verified'])"><i
                                    class="fa fa-eye"></i></a></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </cdk-virtual-scroll-viewport>
                    <!-- </cdk-virtual-scroll-viewport> -->
                  </div>
                  <div *ngIf="activesidetab == 'weightage'?true:false"
                    class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm">
                    <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
                      [style.height]="tableData.length > 0 ? '300px' : '185px'">
                      <table class="table text-center table-sm mt-1">

                        <thead class="thead-light">
                          <tr>
                            <th class="positiontest" [style.top]="inverseOfTranslation">
                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" (change)="checkallset(checkall)" name="selectall"
                                  [disabled]="disablechackall" [(ngModel)]="checkall" class="custom-control-input"
                                  id="selectall">
                                <label class="custom-control-label" for="selectall"></label>
                              </div>
                              <input type="checkbox" name="selectall" class="custom-control-input" id="selectall">
                            </th>
                            <th scope="col" class="positiontest" [style.top]="inverseOfTranslation">{{ 'dataSubs.sno' | translate }}</th>
                            <th>{{ 'trigManage.statename' | translate }}</th>
                            <th>{{ 'trigManage.view' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody class="text-white">
                          <ng-container *cdkVirtualFor="let table of tableData;let i=index">
                            <tr>
                              <td>
                                <div class="custom-control custom-checkbox">
                                  <input [disabled]="table['checkboxdisb']" type="checkbox" class="custom-control-input"
                                    [(ngModel)]="table['ischecked']" id="{{i+1}}">
                                  <label class="custom-control-label" for="{{i+1}}"></label>
                                </div>
                              </td>
                              <td scope="row">{{i+1}}</td>
                              <td scope="row">{{table['statename']}}</td>
                              <td><a class="pointer" title="View Data"
                                  (click)="infoClick(table['indicatordata'], table['id'], table['statename'])"><i
                                    class="fa fa-eye"></i></a></td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </cdk-virtual-scroll-viewport>
                  </div>
                  <div class="row" *ngIf="tableData.length == 0">
                    <div class="col-12 nodata">
                      {{'infotab.nodata' | translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
